<template>
  <div>
    <ul id="menu" class="menu">
      <li class="menu-item" v-for="item in navItems.items" :key="item.name">
        <a :href="`/c/${item.slug}`" class="menu-link">{{item.title}}</a>
        <div class="afu-dropdown-content" v-if="item.child_items">
          <p v-for="childItem in item.child_items" :key="childItem.ID">
            <a v-if="childItem.object==='category'" :href="`/c/${childItem.slug}`">{{ childItem.title }}</a>
            <a v-if="childItem.object==='page'" :href="`/p/${childItem.slug}`">{{ childItem.title }}</a>
          </p>
        </div>
      </li>
      <Search class="form"/>
    </ul>
  </div>
</template>
<script>
  import axios from 'axios'
  import Search from './search/Search'

  export default {
    name: 'Navigation',
    components: {
      Search
    },
    data:() => {
      return {
        navItems: [],
        posts: [],
      }
   },
   created () {
    this.getMenuItems ()
   },
   methods: {
    getMenuItems () {
      axios.get('https://foto-urbana.credopop.com/wp-json/menus/v1/menus/primary-menu')
      .then(response => {
        this.navItems = response.data
        console.log(response.data)
      })
      .catch(e => {
        console.log(e)
      })
    },
  }
}
</script>
<style scoped>
a,
a:link,
a:visited,
a:active {
  color: #000000;
  opacity: 1.0;
  text-decoration: none;
}

a:hover {
  color: #000000;
  opacity: 1.0;
  text-decoration: none;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 99999999999999;
  top: 0;
  left: 0;
  background-color: rgb(255, 255, 255);
  overflow-x: hidden;
  transition: 0.5s;
}
#menu {
  position: relative;
}
.menu {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 12px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 75px;
}
.menu-item {
  font-size: 12px;
  color: #000000;
  height: 50px;
}

.menu-item:not(:last-child) {
  padding-left: 35px;
}

li.menu-item {
  margin-top: 20px;
}
.menu-link {
  opacity: 1;
  transition: all 0.3s ease-in-out;
  color: #000000;
  text-decoration: none;
  padding: 5px;
  cursor: pointer;
}
.menu-link:hover {
  background-image: url('../../assets/focus.svg');
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 0px 2px;
  transition: all .1s ease-out;
}
.menu-item a {
  z-index: 100;
}
.menu-item span {
  z-index: -1;
}
.menu-link:hover:before  {
  background: #000;
  width: 10px;
  height: 10px;
}
ul {
  list-style-type: none;
}
.afu-dropdown-content {
  display: none;
  background-color: #e5e5e5;
  padding: 25px 50px;
  min-width: 150px;
  word-break: keep-all;
  flex-wrap: nowrap;
  white-space: nowrap;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 20%);
  margin-top: 20px;
  transition: all .5s ease-in;
  z-index: 100000;
  width: 1280px;
}
.afu-dropdown-content p {
  color: #000;
  text-decoration: none;
  padding: 5px;
  margin-bottom: 0;
}
.afu-dropdown-content p:not(:last-child) {
  margin-right: 50px;
}
.afu-dropdown-content p:hover {
  background-image: url('../../assets/focus-blanco.svg');
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 0px 2px;
  transition: all .1s ease-out;
}
#menu li:hover>.afu-dropdown-content {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  transition: all .8s ease-in;
  position: absolute;
  right:0;
}
</style>
